<script setup lang="ts">
import { setupGlobalErrors } from '@/composables/useErrors';
import { useRouteMessages } from '@/composables/useRouteMessages';

// Renderless: lives inside <BApp> so useToast() can resolve its injection.
// Caches the toast service for non-component callers (Pinia Colada global hooks).
setupGlobalErrors();

// Toasts the successMessage/errorMessage query parameters server-side redirects
// use to report their outcome, on whichever page they land.
useRouteMessages();
</script>

<template></template>
